<template>
  <div>
    <b-row>
      <b-col xl="6">
        <b-card class="db-chart-card">
          <template v-slot:header>
            <b-row>
              <b-col xl="6"
                ><h5 class="db-chart-title mb-0">Faturação</h5></b-col
              >
              <b-col xl="6" class="text-right">
                <button
                  class="db-toggle-btn"
                  :class="{ active: modoFaturacao === 'mensal' }"
                  @click="setModo('faturacao', 'mensal')"
                >
                  Mensal
                </button>
                <button
                  class="db-toggle-btn"
                  :class="{ active: modoFaturacao === 'semanal' }"
                  @click="setModo('faturacao', 'semanal')"
                >
                  Semanal
                </button>
              </b-col>
            </b-row>
          </template>
          <div class="chart">
            <line-chart
              :height="350"
              :chart-data="chartFaturacao.data"
              :extra-options="chartFaturacao.options"
            />
          </div>
        </b-card>
      </b-col>

      <b-col xl="6">
        <b-card class="db-chart-card">
          <template v-slot:header>
            <b-row>
              <b-col xl="6"
                ><h5 class="db-chart-title mb-0">Cartões Emitidos</h5></b-col
              >
              <b-col xl="6" class="text-right">
                <button
                  class="db-toggle-btn"
                  :class="{ active: modoCartõesEmitidos === 'mensal' }"
                  @click="setModo('cartoesEmitidos', 'mensal')"
                >
                  Mensal
                </button>
                <button
                  class="db-toggle-btn"
                  :class="{ active: modoCartõesEmitidos === 'semanal' }"
                  @click="setModo('cartoesEmitidos', 'semanal')"
                >
                  Semanal
                </button>
              </b-col>
            </b-row>
          </template>
          <div class="chart">
            <bar-chart
              :height="350"
              :chart-data="chartCartoesEmitidos.data"
              :extra-options="chartCartoesEmitidos.options"
            />
          </div>
        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col xl="6">
        <b-card class="db-chart-card">
          <template v-slot:header>
            <b-row>
              <b-col xl="6"
                ><h5 class="db-chart-title mb-0">Ticket Médio</h5></b-col
              >
              <b-col xl="6" class="text-right">
                <button
                  class="db-toggle-btn"
                  :class="{ active: modoTicket === 'mensal' }"
                  @click="setModo('ticket', 'mensal')"
                >
                  Mensal
                </button>
                <button
                  class="db-toggle-btn"
                  :class="{ active: modoTicket === 'semanal' }"
                  @click="setModo('ticket', 'semanal')"
                >
                  Semanal
                </button>
              </b-col>
            </b-row>
          </template>
          <div class="chart">
            <line-chart
              :height="350"
              :chart-data="chartTicket.data"
              :extra-options="chartTicket.options"
            />
          </div>
        </b-card>
      </b-col>

      <b-col xl="6">
        <b-card class="db-chart-card">
          <template v-slot:header>
            <b-row>
              <b-col xl="6"
                ><h5 class="db-chart-title mb-0">Cartões Utilizados</h5></b-col
              >
              <b-col xl="6" class="text-right">
                <button
                  class="db-toggle-btn"
                  :class="{ active: modoCartoesUsados === 'mensal' }"
                  @click="setModo('cartoesUsados', 'mensal')"
                >
                  Mensal
                </button>
                <button
                  class="db-toggle-btn"
                  :class="{ active: modoCartoesUsados === 'semanal' }"
                  @click="setModo('cartoesUsados', 'semanal')"
                >
                  Semanal
                </button>
              </b-col>
            </b-row>
          </template>
          <div class="chart">
            <bar-chart
              :height="350"
              :chart-data="chartCartoesUsados.data"
              :extra-options="chartCartoesUsados.options"
            />
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import LineChart from "@/components/Charts/LineChart";
  import BarChart from "@/components/Charts/BarChart";

  const DATALABELS_NUM = {
    display: true,
    color: "#373737",
    font: { weight: "bold" },
    anchor: "end",
    align: "top",
    offset: 10,
    clamp: true,
  };
  const DATALABELS_EURO = {
    ...DATALABELS_NUM,
    formatter: (v) => `${v} €`,
  };

  export default {
    name: "DashboardGraficos",
    components: { LineChart, BarChart },
    props: {
      dados: { type: Object, default: () => ({}) },
    },
    data() {
      return {
        modoFaturacao: "mensal",
        modoCartõesEmitidos: "mensal",
        modoTicket: "mensal",
        modoCartoesUsados: "mensal",
      };
    },
    computed: {
      chartFaturacao() {
        const lista =
          this.modoFaturacao === "mensal"
            ? this.dados.faturacaoMensal || []
            : this.dados.faturacaoSemanal || [];
        return {
          data: {
            labels:
              this.modoFaturacao === "mensal"
                ? lista.map((d) => d.mes)
                : lista.map((d) => `${d.inicio_semana} - ${d.fim_semana}`),
            datasets: [
              {
                label: "Faturação (€)",
                data: lista.map((d) => Math.round(d.faturacao)),
                borderColor: "#ff825d",
                backgroundColor: "#ff825d",
                fill: false,
              },
            ],
          },
          options: {
            layout: { padding: { top: 28 } },
            plugins: { datalabels: DATALABELS_EURO },
          },
        };
      },
      chartCartoesEmitidos() {
        const lista =
          this.modoCartõesEmitidos === "mensal"
            ? this.dados.cartoesEmitidosMensal || []
            : this.dados.cartoesEmitidosSemanal || [];
        return {
          data: {
            labels:
              this.modoCartõesEmitidos === "mensal"
                ? lista.map((d) => d.mes)
                : lista.map((d) => `${d.inicio_semana} - ${d.fim_semana}`),
            datasets: [
              {
                label: "Cartões Emitidos",
                data: lista.map((d) => d.cartoes_emitidos),
                borderRadius: 0,
              },
            ],
          },
          options: {
            layout: { padding: { top: 28 } },
            plugins: { datalabels: DATALABELS_NUM },
          },
        };
      },
      chartTicket() {
        const lista =
          this.modoTicket === "mensal"
            ? this.dados.ticketMensal || []
            : this.dados.ticketSemanal || [];
        return {
          data: {
            labels:
              this.modoTicket === "mensal"
                ? lista.map((d) => d.mes)
                : lista.map((d) => `${d.inicio_semana} - ${d.fim_semana}`),
            datasets: [
              {
                label: "Ticket Médio (€)",
                data: lista.map((d) => Math.round(d.ticket_medio)),
                borderColor: "#ff825d",
                backgroundColor: "#ff825d",
                fill: false,
              },
            ],
          },
          options: {
            layout: { padding: { top: 28 } },
            plugins: { datalabels: DATALABELS_EURO },
          },
        };
      },
      chartCartoesUsados() {
        const lista =
          this.modoCartoesUsados === "mensal"
            ? this.dados.cartoesUsadosMensal || []
            : this.dados.cartoesUsadosSemanal || [];
        return {
          data: {
            labels:
              this.modoCartoesUsados === "mensal"
                ? lista.map((d) => d.mes)
                : lista.map((d) => `${d.inicio_semana} - ${d.fim_semana}`),
            datasets: [
              {
                label: "Cartões Utilizados",
                data: lista.map((d) => Number(d.cartoes_usados) || 0),
                borderRadius: 0,
              },
            ],
          },
          options: {
            layout: { padding: { top: 28 } },
            plugins: { datalabels: DATALABELS_NUM },
          },
        };
      },
    },
    methods: {
      setModo(grafico, modo) {
        if (grafico === "faturacao") this.modoFaturacao = modo;
        if (grafico === "cartoesEmitidos") this.modoCartõesEmitidos = modo;
        if (grafico === "ticket") this.modoTicket = modo;
        if (grafico === "cartoesUsados") this.modoCartoesUsados = modo;
      },
    },
  };
</script>
